/**
 * @extends storeLocator.StaticDataFeed
 * @constructor
 */
function DaiwaDataSource() {
  $.extend(this, new storeLocator.StaticDataFeed);

  var that = this;
  var cacheKey = 'staticStoreData';
  var cacheExpiryKey = 'staticStoreDataExpiry';
  var cacheExpiryHours = 24; // Cache for 24 hours

  // Check if cached data exists and is not expired
  var cachedData = localStorage.getItem(cacheKey);
  var cachedExpiry = localStorage.getItem(cacheExpiryKey);
  var now = new Date().getTime();

  if (cachedData && cachedExpiry && now < parseInt(cachedExpiry)) {
    // Use cached data
    that.setStores(that.parse_(cachedData));
  } else {
    // Fetch new data
    $.get('https://sheets.googleapis.com/v4/spreadsheets/1j70_sA1FJ539C9s4pCf9rI-nsUmiuJBSDX0bUZZKFjA/values:batchGet?ranges=A1:Z1000&key=AIzaSyBxndKCpLv4kwiAu16Rvs-2acYybb_HQeo', function (data) {
      var csv = '';
      for (i = 0; i < data.valueRanges['0'].values.length; i++) {
        var cellData = [];
        for (x = 0; x < data.valueRanges['0'].values[i].length; x++) {
          cellData[x] = data.valueRanges['0'].values[i][x].replace(',', ';');
        }
        csv += cellData + '\n';
      }
      // Cache the data
      localStorage.setItem(cacheKey, csv);
      localStorage.setItem(cacheExpiryKey, (now + cacheExpiryHours * 60 * 60 * 1000).toString());
      that.setStores(that.parse_(csv));
    });
  }
}
/**
 * @const
 * @type {!storeLocator.FeatureSet}
 * @private
 */
/**
 * @return {!storeLocator.FeatureSet}
 */
DaiwaDataSource.prototype.getFeatures = function () {
  return this.FEATURES_;
};

/**
 * @private
 * @param {string} csv
 * @return {!Array.<!storeLocator.Store>}
 */
DaiwaDataSource.prototype.parse_ = function (csv) {

  var stores = [];
  var rows = csv.split('\n');
  var headings = this.parseRow_(rows[0]);
  for (var i = 1; i < rows.length; i++) {

    var singleCell = rows[i].split(',');
    var singleHead = headings[0].split(',');
    var singleObject = {};
    for (var x = 0; x < singleHead.length; x++) {
      if (singleCell[x] != null && singleCell[x] != '') {
        var cleanCell = singleCell[x].replace(";", ",")
        var cleanHeader = singleHead[x].replace(/(\r\n|\n|\r)/gm, "");
        singleObject[cleanHeader] = cleanCell;
      }
    }

    var position = new google.maps.LatLng(singleObject.Latitude, singleObject.Longitude);
    var street = this.join_([singleObject.Shop_Number, singleObject.Shop_Street], ' ');
    var shop = this.join_([street, singleObject.Shop_City], ', ');
    var locality = this.join_([singleObject.Shop_State, singleObject.Shop_Postcode], ', ');
    var directions = new storeLocator.Feature('2', '<a class="action directions" href="https://www.google.com/maps/search/?api=1&query=' + shop.split(' ').join('+') + ',' + locality.split(' ').join('+') + '" onclick="clickDirectionStore(\'' + singleObject.Shop_Name + '\')" target="_blank"><svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2391_217)"><path d="M13.9219 7.58499C13.9219 10.4453 11.0201 13.4663 9.87713 14.5477C9.74637 14.6531 9.58641 14.7102 9.42188 14.7102C9.25734 14.7102 9.09738 14.6531 8.96662 14.5477C7.82437 13.4663 4.92188 10.4453 4.92188 7.58499C4.92188 6.32521 5.39598 5.11703 6.23989 4.22623C7.08381 3.33544 8.2284 2.83499 9.42188 2.83499C10.6153 2.83499 11.7599 3.33544 12.6039 4.22623C13.4478 5.11703 13.9219 6.32521 13.9219 7.58499Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.42188 9.16835C10.2503 9.16835 10.9219 8.45946 10.9219 7.58501C10.9219 6.71056 10.2503 6.00168 9.42188 6.00168C8.59345 6.00168 7.92188 6.71056 7.92188 7.58501C7.92188 8.45946 8.59345 9.16835 9.42188 9.16835Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/><path d="M6.95706 12.335H4.17456C4.0173 12.3351 3.86405 12.3873 3.73646 12.4844C3.60887 12.5814 3.51341 12.7183 3.46356 12.8757L1.96056 17.6257C1.92288 17.7447 1.91253 17.8715 1.93037 17.9955C1.94821 18.1196 1.99373 18.2374 2.06317 18.3392C2.13261 18.441 2.22399 18.524 2.32977 18.5812C2.43554 18.6384 2.55269 18.6683 2.67156 18.6684H16.1716C16.2903 18.6683 16.4074 18.6384 16.5131 18.5812C16.6188 18.524 16.7101 18.4411 16.7795 18.3394C16.849 18.2377 16.8945 18.12 16.9124 17.9961C16.9303 17.8721 16.9201 17.7455 16.8826 17.6265L15.3826 12.8765C15.3328 12.7188 15.2373 12.5816 15.1095 12.4845C14.9818 12.3873 14.8283 12.335 14.6708 12.335H11.8868" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_2391_217"><rect width="18" height="19" fill="white" transform="translate(0 0.0641785)"/></clipPath></defs></svg>DIRECTIONS</a>');

    if(singleObject.Website) {
      if(singleObject.Website.indexOf('http') > -1) {
        var web_url = singleObject.Website;
      }
      else {
        var web_url = 'https://' + singleObject.Website;
      }
      var website = new storeLocator.Feature('3', '<a class="action website" data-link="'+ web_url +'" href="' + web_url + '" onclick="clickWebsiteStore(\'' + web_url + '\')" target="_blank"><svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.35547 5.59618L5.58556 2.10493C5.72184 1.95676 5.8839 1.8392 6.0624 1.75903C6.24091 1.67887 6.43233 1.63768 6.62563 1.63785H12.7342C12.9275 1.63768 13.119 1.67887 13.2975 1.75903C13.476 1.8392 13.638 1.95676 13.7743 2.10493L17.0044 5.59618" stroke="#0F0868" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.82031 9.5545V15.8878C3.82031 16.3078 3.97465 16.7105 4.24937 17.0074C4.52409 17.3044 4.89669 17.4712 5.28521 17.4712H14.0746C14.4631 17.4712 14.8357 17.3044 15.1104 17.0074C15.3851 16.7105 15.5395 16.3078 15.5395 15.8878V9.5545" stroke="#0F0868" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.8771 17.4712V14.3045C11.8771 13.8846 11.7228 13.4818 11.448 13.1849C11.1733 12.888 10.8007 12.7212 10.4122 12.7212H8.94732C8.5588 12.7212 8.1862 12.888 7.91148 13.1849C7.63676 13.4818 7.48242 13.8846 7.48242 14.3045V17.4712" stroke="#0F0868" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.35547 5.59616H17.0044" stroke="#0F0868" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.0044 5.59616V7.97116C17.0044 8.39109 16.8501 8.79381 16.5753 9.09075C16.3006 9.38768 15.928 9.55449 15.5395 9.55449C15.1116 9.52904 14.7029 9.354 14.3749 9.05574C14.2875 8.98748 14.1824 8.95074 14.0746 8.95074C13.9668 8.95074 13.8617 8.98748 13.7743 9.05574C13.4464 9.354 13.0377 9.52904 12.6097 9.55449C12.1818 9.52904 11.7731 9.354 11.4451 9.05574C11.3577 8.98748 11.2527 8.95074 11.1448 8.95074C11.037 8.95074 10.9319 8.98748 10.8445 9.05574C10.5166 9.354 10.1079 9.52904 9.67994 9.55449C9.25199 9.52904 8.84328 9.354 8.51535 9.05574C8.42795 8.98748 8.32287 8.95074 8.21504 8.95074C8.10722 8.95074 8.00213 8.98748 7.91474 9.05574C7.5868 9.354 7.17809 9.52904 6.75015 9.55449C6.32221 9.52904 5.9135 9.354 5.58556 9.05574C5.49816 8.98748 5.39308 8.95074 5.28526 8.95074C5.17743 8.95074 5.07235 8.98748 4.98495 9.05574C4.65701 9.354 4.2483 9.52904 3.82036 9.55449C3.43185 9.55449 3.05925 9.38768 2.78453 9.09075C2.50981 8.79381 2.35547 8.39109 2.35547 7.97116V5.59616" stroke="#0F0868" stroke-linecap="round" stroke-linejoin="round"/></svg>VIEW STORE DETAILS</a>');
    }
    else {
      var website = '';
    }
    var features = new storeLocator.FeatureSet(directions, website);

    if (singleObject.Phone_Number == null) {
      var isTelHidden = 'd-none';
    } else {
      var isTelHidden = '';
    }

    var store = new storeLocator.Store(i, position, features, {
      title: singleObject.Shop_Name,
      phone: '<a href="tel:' + singleObject.Phone_Number + '" onclick="clickCallStore(\'' + singleObject.Shop_Name + '\')" class="' + isTelHidden + '">Call for availability <span>' + singleObject.Phone_Number + '</span></a>',
    });
    stores.push(store);
  }

  return stores;
};


/**
 * Joins elements of an array that are non-empty and non-null.
 * @private
 * @param {!Array} arr array of elements to join.
 * @param {string} sep the separator.
 * @return {string}
 */
DaiwaDataSource.prototype.join_ = function (arr, sep) {
  var parts = [];
  for (var i = 0, ii = arr.length; i < ii; i++) {
    arr[i] && parts.push(arr[i]);
  }
  return parts.join(sep);
};

/**
 * Very rudimentary CSV parsing - we know how this particular CSV is formatted.
 * IMPORTANT: Don't use this for general CSV parsing!
 * @private
 * @param {string} row
 * @return {Array.<string>}
 */
DaiwaDataSource.prototype.parseRow_ = function (row) {
  // Strip leading quote.
  if (row.charAt(0) == '"') {
    row = row.substring(1);
  }
  // Strip trailing quote. There seems to be a character between the last quote
  // and the line ending, hence 2 instead of 1.
  if (row.charAt(row.length - 2) == '"') {
    row = row.substring(0, row.length - 2);
  }

  row = row.split('","');

  return row;
};

/**
 * Creates an object mapping headings to row elements.
 * @private
 * @param {Array.<string>} headings
 * @param {Array.<string>} row
 * @return {Object}
 */
DaiwaDataSource.prototype.toObject_ = function (headings, row) {
  var result = {};
  for (var i = 0, ii = row.length; i < ii; i++) {
    result[headings[i]] = row[i];
  }
  return result;
};
